/** ORDAN Brand Guidelines v1.0 — canonical product identity constants. */

export const PRODUCT_NAME = 'ORDAN';
export const PRODUCT_CATEGORY = 'Enterprise Operating System';
export const PRODUCT_TAGLINE = 'Business, in order.';
export const PRODUCT_SUPPORTING_COPY =
  'Run finance, supply, projects, people, assets and operations as one connected enterprise.';

/** Core philosophy line from brand guidelines. */
export const PRODUCT_PHILOSOPHY = 'Complexity is inevitable. Disorder is not.';

/** Concise one-line definition. */
export const PRODUCT_DEFINITION =
  'ORDAN is the Enterprise Operating System for complex businesses.';

/** Secondary brand language (use sparingly; primary tagline takes precedence). */
export const PRODUCT_SECONDARY_LINES = [
  'Complexity is inevitable. Disorder is not.',
  'The system behind enterprise.',
  'Know. Control. Execute.',
  'One connected enterprise.',
  'Built for complex enterprise.',
] as const;

/**
 * Official ORDAN colour palette (Brand Guidelines §10).
 * Prefer these over ad-hoc hex in new UI.
 */
export const ORDAN_PALETTE = {
  teal: '#145A54',
  accentTeal: '#36C7BE',
  deepMidnight: '#0B1720',
  obsidian: '#101820',
  warmWhite: '#F7F8F7',
  softGrey: '#E8ECEB',
  operationalGrey: '#66727A',
  white: '#FFFFFF',
} as const;

/** Aliases matching guideline role names. */
export const ORDAN_TEAL = ORDAN_PALETTE.teal;
export const ORDAN_ACCENT_TEAL = ORDAN_PALETTE.accentTeal;

/** Demo-only WITHU identity used by `/loginwithu`; the live product stays ORDAN. */
export const WITHU_BRAND = {
  name: 'WITHU',
  logoSrc: '/brand/withu-logo.png',
  navy: '#1B4F8C',
  green: '#3DBE4A',
} as const;

export type AuthBrand = 'ordan' | 'withu';

export interface BrandCapabilitySlide {
  id: number;
  eyebrow: string;
  category: string;
  title: string;
  description: string;
}

export const BRAND_CAPABILITY_SLIDES: BrandCapabilitySlide[] = [
  {
    id: 1,
    eyebrow: '01 / 03',
    category: 'KNOW',
    title: 'See the enterprise as it is.',
    description: 'Bring financial, operational and organizational context together in one live view.',
  },
  {
    id: 2,
    eyebrow: '02 / 03',
    category: 'CONTROL',
    title: 'Turn policy into operation.',
    description: 'Embed authority, approvals, budgets, compliance and accountability into everyday execution.',
  },
  {
    id: 3,
    eyebrow: '03 / 03',
    category: 'EXECUTE',
    title: 'Move decisions into action.',
    description: 'Coordinate people, processes and systems from decision through measurable outcome.',
  },
];
